import { createContext } from "react";

const OnlineClassContext = createContext();

export default OnlineClassContext;